export const GIFTBOX_LANDING_URL_LABEL = 'caja-regalo';
export const GIFTBOX_WIZARD_URL_LABEL = 'caja-regalo/configurador';
